// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tg-2";
export var container = "_tg-4";
export var dismissButton = "_tg-3";
export var hasPaddingBottom = "_tg-6";
export var last = "_tg-e";
export var scrollbarThumb = "_tg-c";
export var scrollbarTrack = "_tg-b";
export var selected = "_tg-9";
export var spin = "_tg-1";
export var spinning = "_tg-0";
export var suggestionItem = "_tg-d";
export var suggestionsPanel = "_tg-5";
export var tonePill = "_tg-8";
export var tonesContainer = "_tg-7";
export var unselected = "_tg-a";